import { render, staticRenderFns } from "./PlayerRadar.vue?vue&type=template&id=123ee497"
import script from "./PlayerRadar.vue?vue&type=script&lang=js"
export * from "./PlayerRadar.vue?vue&type=script&lang=js"
import "./PlayerRadar.vue?vue&type=style&index=0&id=123ee497&prod&lang=scss"
/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports